import { ConnexionPageState } from "../ConnexionPageState";
import { ConnexionPageInitial } from "./ConnexionPageInitial";

/** Etat de gestion d'un oublie de mot de passe */
export class ConnexionPageAbout extends ConnexionPageState{
    
    /** Ferme la demande d'affichage d'information "à propos de" */
    public async Abord(): Promise<void> {
        this.context.ShowAboutInformations = false;
        this.context.State = new ConnexionPageInitial(this.context);
    }

    //#region CAS INGORE
    /** VOID */
    public async SignIn(): Promise<void> { /** Non proposé à l'utilisateur */ }

    /** VOID */
    public ResetPassword(): void { /** Non proposé à l'utilisateur */ }

    /** VOID */
    public async SendMail(): Promise<void> { /** Non proposé à l'utilisateur */ }
    
    /** VOID */
    public About(): void { /** Non proposé à l'utilisateur */ }
    //#endregion CAS INGORE
}